/* __next_internal_client_entry_do_not_use__ useSDUIFilterablePaginatedSectionState auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
// move to generic query params in the future
import { useZustandLocation } from "@faire/retailer-visitor-shared/app/_lib/routing/useZustandLocation";
import { uniqueAndSorted } from "@faire/retailer-visitor-shared/lib/uniqueAndSorted";
import { isTupleOfLength } from "@faire/web--source/common/typescriptUtils";
import { useQueryParams } from "@faire/web--source/ui/hooks/useQueryParams";
import { QueryParameters } from "@faire/web-api--source/routes/category/c1CategoryUrlId";
import qs from "query-string";
import { useEffect, useMemo, useRef } from "react";
import { useHistory } from "react-router-dom";
// This is non RSC compatible. Use useServerCompatibleSDUIFilterablePaginatedSectionState instead.
export var useSDUIFilterablePaginatedSectionState = function() {
    var pathname = useZustandLocation(function(state) {
        return state.pathname;
    }).pathname;
    var history = useHistory();
    var queryParams = useQueryParams(QueryParameters.parse);
    var updateQueryParamsAndStringify = useUpdateQueryParamsAndStringify(queryParams);
    var filters = queryParams.filters;
    var uniqueSortedFilterKeys = useMemo(function() {
        // This is to support standard query params like `?filters=k1&filters=k2`
        var normalizedFiltersQueryParams = filters && isTupleOfLength(filters, 1) ? filters[0].split(",") : filters !== null && filters !== void 0 ? filters : [];
        return uniqueAndSorted(normalizedFiltersQueryParams);
    }, [
        filters
    ]);
    var setFilterKeys = function(updater) {
        var updatedFilterKeys = uniqueAndSorted(updater(uniqueSortedFilterKeys));
        var queryString = updateQueryParamsAndStringify(function(oldParams) {
            return _object_spread_props(_object_spread({}, oldParams), {
                filters: updatedFilterKeys.length === 0 ? undefined : [
                    updatedFilterKeys.join(",")
                ]
            });
        });
        history.push({
            pathname: pathname,
            search: queryString
        });
    };
    var _queryParams_page;
    var oneIndexedPageNumber = (_queryParams_page = queryParams.page) !== null && _queryParams_page !== void 0 ? _queryParams_page : 1;
    var setOneIndexedPageNumber = function(updater) {
        var _queryParams_page;
        var newPageNumber = updater((_queryParams_page = queryParams.page) !== null && _queryParams_page !== void 0 ? _queryParams_page : 1);
        var queryString = updateQueryParamsAndStringify(function(oldParams) {
            return _object_spread_props(_object_spread({}, oldParams), {
                page: newPageNumber === 1 ? undefined : newPageNumber
            });
        });
        history.push({
            pathname: pathname,
            search: queryString
        });
    };
    var clearOneIndexedPageNumber = function() {
        setOneIndexedPageNumber(function() {
            return 1;
        });
    };
    return {
        filterKeys: uniqueSortedFilterKeys,
        setFilterKeys: setFilterKeys,
        oneIndexedPageNumber: oneIndexedPageNumber,
        clearOneIndexedPageNumber: clearOneIndexedPageNumber
    };
};
var useUpdateQueryParamsAndStringify = function(queryParams) {
    var queryParamsInMemory = useRef(queryParams);
    useEffect(function() {
        queryParamsInMemory.current = queryParams;
    }, [
        queryParams
    ]);
    return function(updater) {
        queryParamsInMemory.current = updater(queryParamsInMemory.current);
        return qs.stringify(queryParamsInMemory.current);
    };
};
